import { render, staticRenderFns } from "./OfflineScore.vue?vue&type=template&id=dd156580&scoped=true"
import script from "./OfflineScore.vue?vue&type=script&lang=js"
export * from "./OfflineScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd156580",
  null
  
)

export default component.exports